// extracted by mini-css-extract-plugin
export default {"txhd":"HomeFooter_txhd__fZ4F1","txsbtl":"HomeFooter_txsbtl__rCE+5","txtrm":"HomeFooter_txtrm__lP7Fs","txtrm2":"HomeFooter_txtrm2__03Cq1","icon":"HomeFooter_icon__Sa69K"};